<div [ngClass]="getIconSizeClasses()" *ngIf="icon">
  <mat-icon [svgIcon]="icon"></mat-icon>
</div>
